export const OLLIE_CAMPAIGN_ID = 'OLLIE_CAMPAIGN_ID';
